import ScriptBlock from "./ScriptBlock.component";

export default ScriptBlock;
